/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import UserCardStatic from './modes/static/static';
import UserCardEditing from './modes/editing/editing';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import style from './userCard.module.scss';
import { DURATIONS } from 'utils/utils';
import cx from 'classnames';

export type ProfileMode = 'static' | 'editing';

export default function UserCard() {
  const [mode, setMode] = useState<ProfileMode>('static');

  return (
    <TransitionGroup
      className={cx(style.container, 'adaptive-userCard__container')}
      component="div"
    >
      {mode === 'static' ? (
        <CSSTransition
          timeout={DURATIONS.PROFILE_SWITCH}
          classNames="userCard-tg"
          key={'1'}
        >
          <UserCardStatic onChangeMode={setMode}></UserCardStatic>
        </CSSTransition>
      ) : (
        <CSSTransition
          timeout={DURATIONS.PROFILE_SWITCH}
          classNames="userCard-tg"
          key={'2'}
        >
          <UserCardEditing onChangeMode={setMode}></UserCardEditing>
        </CSSTransition>
      )}
    </TransitionGroup>
  );
}
